import { Component, DestroyRef, Inject, PLATFORM_ID, inject, signal } from '@angular/core';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Customer } from '@app/models/customers/Customer';
import { PartnerloginComponent } from '@app/components/modals/partnerlogin/partnerlogin.component';
import { AuthService } from '@app/services/auth.service';
import { OfferpackService } from '@app/services/offerpack.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatService } from '@app/services/chat.service';
import { FavoritesService } from '@app/services/favorites.service';
import { Item } from '@app/models/hotels/Item';
import { Price } from '@app/models/hotels/Price';
import { Menu } from '../Menu';
import { I18nService } from '@app/services/i18n.service';
import { MediaService } from '@app/services/media.service';
import { DEFAULT_PARTNER_ID } from '@app/components/tools/Const';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { PartnerService } from '@app/services/partner.service';
import { ConfigService } from '@app/services/config.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { environment } from '../../../../environments/environment';

export interface PathHistory {
    country: Item;
    region: Item;
    hotel: Item;
    flug: string;
    booking: Price;
}

@Component({
    selector: 'clever-header2',
    templateUrl: './header2.component.html',
    styleUrls: ['./header2.component.scss'],
    standalone: false
})
export class HeaderDefault2Component {
    partner = signal<Partner>(null);;

    isFlugb = signal<boolean>(false);
    menuactive = signal<boolean>(false);
    menuactiveurlaubssuche = signal<boolean>(false);
    menuactiveurlaubsziele = signal<boolean>(false);
    menureisebuerosearch = signal<boolean>(false);
    menuactiveoffice = signal<boolean>(false);
    isBrowser = signal(false);
    openUberuns = signal(false);


    defpartnerid: string = DEFAULT_PARTNER_ID;


    fixsetoultip = signal(false);
    showsearch = signal(false);

    citys = signal([]);

    tooltiptext = signal<string>('');
    logo = signal<string>('');
    partnername = signal<string>('');
    destroyRef = inject(DestroyRef);

    currentCustomer = signal<Customer>(null);
    pathHistory = signal<PathHistory>(null);

    favoritesCount = signal<number>(0);
    offerpackCount = signal<number>(0);
    currentsearchparam = signal<string>('ort');

    plz: string = '';
    ort: string = '';

    overlaypos: ConnectedPosition[] = [
        {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'bottom',
        }];

    constructor(
        protected menu: Menu,
        protected dialog: MatDialog,
        protected authService: AuthService,
        protected router: Router,
        protected favoritesService: FavoritesService,
        protected i18nService: I18nService,
        protected mediaService: MediaService,
        protected chatService: ChatService,
        protected route: ActivatedRoute,
        protected partnerService: PartnerService,
        protected clipboard: Clipboard,
        protected configService: ConfigService,
        protected guardService: AuthGuardService,
        protected offerpackService: OfferpackService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Inject(DOCUMENT) private document: any,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
        this.isFlugb.set(this.configService.getConfig().isFlugb);
        this.logo.set(this.configService.getConfig().isFlugb ? '../../../../assets/flugboerse/logo.svg' : '../../../../assets/tvg/logo.svg')
    }

    ngOnInit(): void {
        this.initPartner();
        this.initFavoriten();
        this.initOfferpack();
        if (this.isBrowser()) {
            this.getCitys();
        }
    }

    async activeUberuns(value: boolean) {
        this.menuactiveurlaubssuche.set(false);
        this.menuactiveurlaubsziele.set(false);
        this.menuactiveoffice.set(false);
        this.menuactive.set(false);
        this.openUberuns.set(value);
    }

    async activeBueroSearch(value: boolean) {
        this.menuactiveurlaubssuche.set(false);
        this.menuactiveurlaubsziele.set(false);
        this.menuactiveoffice.set(false);
        this.menuactive.set(false);
        this.openUberuns.set(false);
        this.menureisebuerosearch.set(value);
    }

    async getCitys() {
        this.partnerService.request({}, 'getcitys').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((citys) => {
            this.citys.set(citys);
        });
    }

    async initOfferpack() {
        this.offerpackService.offerpack$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((count: number) => {
            this.offerpackCount.set(count);
        });
    }

    async initFavoriten() {
        this.favoritesService.favorites$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((count: number) => {
            this.favoritesCount.set(count);
        });
    }

    async changeLng(lang) {
        window.localStorage.setItem('current_language', lang);
        this.i18nService.setLanguage(lang);
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((obj) => {
            if (obj?.partnerid?.length > 0) {
                this.partner.set(obj);
                this.tooltiptext.set(this.partner()?.tel + '\nBeratung & Buchung täglich von \n\n' + (this.partner()?.opening_period ? this.partner().opening_period : ''));
                if (this.partner()?.logo?.length > 0 && environment.production) {
                    const dmn = this.document.location.hostname === 'localhost' ? 'localhost:4200' : this.document.location.hostname;
                    this.logo.set('https://' + dmn + '/logo/' + this.partner().partnerid + '/' + this.partner().logo);
                }


                if (obj?.firstname?.length > 0) {
                    this.partnername.set(obj.firstname + ' ' + obj.lastname);
                }
                this.initData();
            } else {
                this.partner.set(null);
                this.partnername.set('');
            }
        });
    }

    async initData() {
        this.authService.auth$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((customer: Customer) => {
            this.currentCustomer.set(customer);
        });
        this.pathHistory.set({} as PathHistory);
    }

    closeMenu(ev) {
        ev?.stopPropagation();
        this.menuactive.set(false);
    }

    async gotobwurl() {
        if (this.partner().burobewertenurl?.length > 0) {
            const link = document.createElement('a');
            link.href = this.partner().burobewertenurl;
            link.target = '_blank';
            link.click();
        }
    }

    openMenu(ev) {
        ev?.stopPropagation();
        this.menuactiveurlaubssuche.set(false);
        this.menuactiveurlaubsziele.set(false);
        this.menuactiveoffice.set(false);
        this.menureisebuerosearch.set(false);
        this.menuactive.set(true);
    }

    closeMenuurlaubssuchen(ev) {
        ev?.stopPropagation();
        this.menuactiveurlaubssuche.set(false);
    }

    closeMenuureisebuerosearch(ev) {
        ev?.stopPropagation();
        this.menureisebuerosearch.set(false);
    }

    openMenuurlaubssuchen(ev) {
        ev?.stopPropagation();
        this.menuactive.set(false);
        this.menuactiveurlaubsziele.set(false);
        this.menuactiveoffice.set(false);
        this.menureisebuerosearch.set(false);
        this.menuactiveurlaubssuche.set(true);
    }

    closeMenuoffice(ev) {
        ev?.stopPropagation();
        this.menuactiveoffice.set(false);
    }

    openMenuoffice(ev) {
        ev?.stopPropagation();
        this.menuactive.set(false);
        this.menuactiveurlaubsziele.set(false);
        this.menureisebuerosearch.set(false);
        this.menuactiveoffice.set(true);
        this.menuactiveurlaubssuche.set(false);
    }

    closeMenuurlaubsziele(ev) {
        ev?.stopPropagation();
        this.menuactiveurlaubsziele.set(false);
    }

    openMenuurlaubsziele(ev) {
        ev?.stopPropagation();
        this.menuactive.set(false);
        this.menuactiveurlaubsziele.set(true);
        this.menuactiveoffice.set(false);
        this.menureisebuerosearch.set(false);
        this.menuactiveurlaubssuche.set(false);
    }

    async gotoPartner() {
        let target = {} as MatDialogConfig;
        this.currentCustomer.set({} as Customer);
        this.currentCustomer().partnerid = this.guardService.getPartnerId();
        if (this.mediaService.deskmode()) {
            target = {
                width: '400px',
                panelClass: 'customModal',
                maxHeight: '100vh',
                disableClose: true,
                data: {
                    partnerdomain: this.partner().partnerdomain,
                    password: this.currentCustomer().password,
                    partnerid: this.currentCustomer().partnerid,
                    email: this.currentCustomer().email,
                    modeLogin: true
                }
            };
        } else {
            target = {
                width: '100%',
                height: '100vh',
                maxWidth: '100%',
                panelClass: 'customModal',
                disableClose: true,
                data: {
                    partnerdomain: this.partner().partnerdomain,
                    password: this.currentCustomer().password,
                    partnerid: this.currentCustomer().partnerid,
                    email: this.currentCustomer().email,
                    modeLogin: true
                }
            };
        }
        const diagRef = this.dialog.open(PartnerloginComponent, target);
        diagRef.afterClosed().pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(result => {
            if (result?.token?.length > 0) {
                this.currentCustomer.set(result);
                this.authService.setAuth(this.currentCustomer());
            }
        });
    }

    async logout() {
        // my account
        this.authService.logout(this.partner()?.partnerid).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(() => {
            this.offerpackService.resetOfferpackList();
            this.authService.resetCustomer(this.partner()?.partnerid);
            const url = this.router.createUrlTree(['']).toString();
            this.router.navigateByUrl(url);
        });
    }

    async gotofavorites() {
        const url = this.router.createUrlTree([this.partner().partnerid, 'favorites']).toString();
        this.router.navigateByUrl(url);
    }

    async gotoOfferpack() {
        const url = this.router.createUrlTree([this.partner().partnerid, 'offerpack']).toString();
        // console.log(url)
        this.router.navigateByUrl(url);
    }

    async gotohome() {
        // console.log('jala')
        const url = this.router.createUrlTree(['']).toString();
        // this.router.navigateByUrl(url);
        const link = document.createElement('a');
        link.href = url;
        link.click();
    }

    async gotoCalendar() {
        this.router.navigate([this.partner().partnerid, 'terminkalender']);
    }

    async openChat() {
        this.chatService.setOpenChat();
    }

    async gotoContent() {
        const url = this.router.createUrlTree([this.partner().partnerid, 'contents']).toString();
        this.router.navigateByUrl(url);
    }

    async gotobuerofinden() {
        window.localStorage.setItem('tvg_buerosuche_type', this.currentsearchparam());
        window.localStorage.setItem('tvg_buerosuche_plz', this.plz);
        window.localStorage.setItem('tvg_buerosuche_ort', this.ort);
        const path = this.router.createUrlTree(['buerosuche'], {}).toString();
        const link = document.createElement('a');
        link.href = path;
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    async gotoAnfrage() {
        const url = this.router.createUrlTree([this.partner().partnerid, 'anfrage']).toString();
        this.router.navigateByUrl(url);
    }

    async gototeam() {
        // freiburg/team/

        const path = this.router.createUrlTree([this.partner().partnerid, 'team'], {}).toString();
        const link = document.createElement('a');
        link.href = path;
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    async linkCopy() {
        this.clipboard.copy(this.document.location.origin + '/' + this.partner().partnerid + '/');
    }

    async shareWhatsApp() {
        this.document.open('https://wa.me/?text=' + encodeURIComponent(this.document.location.origin + '/' + this.partner().partnerid + '/'), '_blank', 'noopener');
    }

    async shareFacebook() {
        this.document.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.document.location.origin + '/' + this.partner().partnerid + '/'), '_blank', 'noopener');
    }

    async shareEmail() {
        this.document.open('mailto:?body=' + encodeURIComponent(this.document.location.origin + '/' + this.partner().partnerid + '/'), '_blank', 'noopener');
    }
}
